import { useInstance, onBeforeMount, onBeforeUpdate, inject, createVNode } from 'intact-react';
import { Menu } from './';
import { Icon } from '../icon';
import { isComponentVNode, eachChildren, isTextVNode, isStringOrNumberNotEmpty } from '../utils';
import { ROOT_DROPDOWN } from '../dropdown/dropdown';
export function useDropdown(rootMenu, parentMenu) {
  var instance = useInstance();
  var isTopItem = rootMenu === parentMenu;
  var rootDropdown = inject(ROOT_DROPDOWN, null);
  var subMenuVNode = null;
  var isDropdownMenu = false;
  var tooltipContents;
  var iconVNode;
  var titleVNodes;
  var isCollapse;
  var position = null;
  onBeforeMount(parseChildren);
  onBeforeUpdate(parseChildren);
  parsePosition(rootMenu.get('type'));
  rootMenu.watch('type', parsePosition);
  // hide dropdown menu on select
  instance.on('select', hide);
  function parseChildren() {
    isDropdownMenu = isDropdown(rootMenu);
    tooltipContents = [];
    iconVNode = null;
    titleVNodes = [];
    isCollapse = rootMenu.get('collapse');
    var children = instance.get('children');
    eachChildren(children, function (vNode) {
      if (isComponentVNode(vNode, Menu)) {
        subMenuVNode = vNode;
      } else {
        if (isStringOrNumberNotEmpty(vNode) || isTextVNode(vNode)) {
          // wrap with span for showing text ellipsis
          vNode = createVNode('span', null, vNode);
          tooltipContents.push(vNode);
        } else if (!iconVNode && isComponentVNode(vNode, Icon)) {
          iconVNode = vNode;
        }
        titleVNodes.push(vNode);
      }
    });
  }
  function parsePosition(type) {
    position = type !== 'horizontal' || !isTopItem ? {
      my: 'left top',
      at: 'right+5 top'
    } : {
      my: 'left top',
      at: 'left bottom+5'
    };
  }
  function hide() {
    if (!isTopItem && rootDropdown) {
      rootDropdown.hide(true);
    }
  }
  return function () {
    return {
      isTopItem: isTopItem,
      subMenuVNode: subMenuVNode,
      isDropdownMenu: isDropdownMenu,
      tooltipContents: tooltipContents,
      iconVNode: iconVNode,
      titleVNodes: titleVNodes,
      position: position,
      isCollapse: isCollapse
    };
  };
}
export function isDropdown(rootMenu) {
  var _rootMenu$get = rootMenu.get(),
    collapse = _rootMenu$get.collapse,
    type = _rootMenu$get.type;
  return collapse || type === 'horizontal';
}